import { TUpdateDocumentTemplateVersionParams } from '@commenda/types/src/document-generation';
import { fetcher } from '@commenda/utils';
import { BASE_URL } from './helpers';

export const updateDocumentTemplateVersion = async (
  documentTemplateId: string,
  documentTemplateVersionId: string,
  data: TUpdateDocumentTemplateVersionParams
): Promise<Response> => {
  const res = await fetcher(
    `${BASE_URL}/${documentTemplateId}/version/${documentTemplateVersionId}`,
    {
      method: 'POST',
      body: data,
    }
  );
  return res;
};
